// src/components/onboarding/screens/MatieresScreen.js
import React from 'react';
import OnboardingLayout from '../OnboardingLayout';
import { CheckboxItem, ScreenTitle } from '../OnboardingUI';
import { matieresParClasse, TOTAL_STEPS } from '../onboardingData';

const MatieresScreen = ({ matieres, classe, onChange, onNext, loading, error }) => {
  const matieresOptions = matieresParClasse[classe] || matieresParClasse.seconde;

  const toggleMatiere = (value) => {
    if (value === 'aucune') {
      onChange(matieres.includes('aucune') ? [] : ['aucune']);
    } else {
      const newMatieres = matieres.filter(m => m !== 'aucune');
      if (newMatieres.includes(value)) {
        onChange(newMatieres.filter(v => v !== value));
      } else {
        onChange([...newMatieres, value]);
      }
    }
  };

  const canProceed = matieres.length > 0;

  return (
    <OnboardingLayout
      currentStep={2}
      totalSteps={TOTAL_STEPS}
      canProceed={canProceed}
      onNext={onNext}
      loading={loading}
      error={error}
    >
      <ScreenTitle
        title="Des matières que tu aimes bien ?"
        subtitle="Peu importe tes notes - coche ce qui te parle"
      />

      <div className="flex-1 overflow-y-auto mb-4 pr-1">
        {matieresOptions.map(option => (
          <CheckboxItem
            key={option}
            checked={matieres.includes(option)}
            label={option}
            onClick={() => toggleMatiere(option)}
            disabled={loading || matieres.includes('aucune')}
          />
        ))}
        <div className="h-px bg-gray-700 my-3" />
        <CheckboxItem
          checked={matieres.includes('aucune')}
          label="Honnêtement, aucune vraiment"
          onClick={() => toggleMatiere('aucune')}
          disabled={loading}
        />
      </div>
    </OnboardingLayout>
  );
};

export default MatieresScreen;
